var id = Math.ceil(Math.random() * 10);

module.exports = function() {
    return ++id;
};
